module.exports = __webpack_public_path__ + "img/slider1.c8610513.jpg";